angular.
module("dx.webapp.angular", [
	"digiexam.node",
	"digiexam.components",
	"dx.webapp.roles",
	"dx.webapp.navigation",

	"dx.ui.components.tooltip",
]);
